import { IListing } from "repoV2/features/Listing/Listing.interfaces";
import {
    DEFAULT_SECTIONS,
    default_section_visibilities,
} from "../constants/brandedCommunity.constants";

type IGetDefaultSectionLabelDetailsArgs = {
    listingDetails?: Pick<IListing.IListingDetails, "label_keys">;
    sectionId: number;
};

const default_sections_keys_in_listing_details: Record<
    number,
    IListing.IBrandedCommunityDefaultSectionLabelKeys
> = {
    [DEFAULT_SECTIONS.FEED]: "feed",
    [DEFAULT_SECTIONS.BONUS_OFFERINGS]: "bonus_offerings",
    [DEFAULT_SECTIONS.MEMBERS]: "members",
    [DEFAULT_SECTIONS.CHAT_WITH_CREATOR]: "direct_messages",
};

const DEFAULT_SECTIONS_DEFAULT_LABELS = {
    [DEFAULT_SECTIONS.FEED]: "Feed",
    [DEFAULT_SECTIONS.BONUS_OFFERINGS]: "All Bonus Offerings",
    [DEFAULT_SECTIONS.MEMBERS]: "Members",
};

export const getDefaultSectionDetailsFromListing = ({
    listingDetails,
    sectionId,
}: IGetDefaultSectionLabelDetailsArgs) =>
    listingDetails?.label_keys?.[
        default_sections_keys_in_listing_details[sectionId]
    ] || {};

export const getDefaultSectionLabelTitle = ({
    listingDetails,
    sectionId,
}: IGetDefaultSectionLabelDetailsArgs) =>
    getDefaultSectionDetailsFromListing({
        listingDetails,
        sectionId,
    }).title || DEFAULT_SECTIONS_DEFAULT_LABELS[sectionId];

export const getDefaultSectionLabelIcon = ({
    listingDetails,
    sectionId,
}: IGetDefaultSectionLabelDetailsArgs) =>
    getDefaultSectionDetailsFromListing({
        listingDetails,
        sectionId,
    }).icon;

export const getDefaultSectionVisibility = ({
    listingDetails,
    sectionId,
}: IGetDefaultSectionLabelDetailsArgs) =>
    getDefaultSectionDetailsFromListing({
        listingDetails,
        sectionId,
    }).visibility || default_section_visibilities.default;

export const getDefaultSectionLabelIconWithTitle = ({
    listingDetails,
    sectionId,
}: IGetDefaultSectionLabelDetailsArgs) => {
    const sectionLabelIcon = getDefaultSectionLabelIcon({
        listingDetails,
        sectionId,
    });
    return (
        (sectionLabelIcon ? `${sectionLabelIcon} ` : "") +
        getDefaultSectionLabelTitle({
            listingDetails,
            sectionId,
        })
    );
};
